<!--
    configCheck report panel (design G.5/§4.3) — admin-only per-rule check of a CaseType's exchange
    configuration for one operationKey. Read-mostly tooling: never mutates configuration.
-->
<div class="cw-exchange-config-check-panel surface-card border-round-lg p-3">

    <div class="flex align-items-center gap-2 mb-3">
        <i class="fa-regular fa-clipboard-check text-primary"></i>
        <span class="font-semibold">Konfiguration prüfen</span>
        <p-tag value="Admin" severity="secondary" styleClass="ml-2"></p-tag>
    </div>

    <div class="flex align-items-end gap-3 flex-wrap mb-3">
        <div class="flex flex-column gap-2">
            <label for="cwConfigCheckOperation">Operation</label>
            <p-select id="cwConfigCheckOperation"
                      [options]="operationKeyOptions"
                      optionLabel="label"
                      optionValue="value"
                      [(ngModel)]="selectedOperationKey"
                      styleClass="w-20rem">
            </p-select>
        </div>
        <p-button label="Konfiguration prüfen" icon="fa-regular fa-magnifying-glass"
                  [loading]="busy" [disabled]="!caseTypeId" (onClick)="runCheck()">
        </p-button>
        <p-button label="Alle Operationen prüfen" icon="fa-regular fa-list-check"
                  severity="secondary" [outlined]="true"
                  [loading]="rollupBusy" [disabled]="!caseTypeId" (onClick)="runAllOperations()">
        </p-button>
    </div>

    @if (error) {
        <p-message severity="error" [text]="error" styleClass="w-full mb-3"></p-message>
    }

    @if (busy) {
        <div class="flex flex-column gap-2 mb-3">
            <p-skeleton width="12rem" height="1.5rem"></p-skeleton>
            <p-skeleton width="100%" height="4rem"></p-skeleton>
        </div>
    } @else if (result) {
        <div class="cw-config-check-result border-round-md p-3 mb-3">
            <div class="flex align-items-center gap-3 flex-wrap mb-2">
                <p-tag [value]="result.green ? 'Grün' : 'Rot'"
                       [severity]="result.green ? 'success' : 'danger'"
                       [icon]="result.green ? 'fa-regular fa-circle-check' : 'fa-regular fa-circle-xmark'">
                </p-tag>
                <span class="font-medium">{{ result.findings?.length ?? 0 }} Befunde</span>
            </div>

            @if (result.findings?.length) {
                <div class="mt-2 overflow-auto">
                    <p-table [value]="result.findings" [rows]="10"
                             [paginator]="result.findings.length > 10"
                             styleClass="p-datatable-sm"
                             [rowTrackBy]="trackByRuleId">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Regel</th>
                                <th>Operation</th>
                                <th>Feld</th>
                                <th>Detail</th>
                                <th class="w-9rem">Schwere</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-finding>
                            <tr>
                                <!-- Leere Operation = CaseType-weiter Befund (Skeleton, Zusatzfeld, Zuordnung). -->
                                <td>{{ finding.ruleId }}</td>
                                <td>{{ finding.operationKey || 'Alle' }}</td>
                                <td>{{ finding.fieldKey || '–' }}</td>
                                <td>{{ finding.detail }}</td>
                                <td>
                                    <p-tag [value]="finding.severity" [severity]="severitySeverity(finding.severity)"></p-tag>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            } @else {
                <div class="text-sm text-color-secondary mt-2">
                    <i class="fa-regular fa-circle-check text-green-600 mr-1"></i>Keine Befunde.
                </div>
            }
        </div>
    } @else if (!rollupRows) {
        <div class="text-sm text-color-secondary mb-3">
            Führen Sie eine Konfigurationsprüfung aus, um die Befunde dieser Operation zu sehen.
        </div>
    }

    <!-- "Alle Operationen prüfen" roll-up (Rückfrage Q9) -->
    @if (rollupError) {
        <p-message severity="error" [text]="rollupError" styleClass="w-full mb-3"></p-message>
    }

    @if (rollupBusy) {
        <div class="flex flex-column gap-2">
            <p-skeleton width="16rem" height="1.5rem"></p-skeleton>
            <p-skeleton width="100%" height="4rem"></p-skeleton>
        </div>
    } @else if (rollupRows) {
        <div class="cw-config-check-rollup border-round-md p-3">
            <div class="flex align-items-center gap-2 mb-2">
                <p-tag [value]="rollupGreen ? 'Grün' : 'Rot'" [severity]="rollupGreen ? 'success' : 'danger'"></p-tag>
                <span class="font-medium">Σ {{ rollupTotalFindingCount }} Befunde</span>
            </div>
            <div class="overflow-auto">
                <p-table [value]="rollupRows" styleClass="p-datatable-sm" [rowTrackBy]="trackByOperationKey">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Operation</th>
                            <th class="w-8rem">Befunde</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ operationLabel(row.operationKey) }}</td>
                            <td>{{ row.findingCount }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    }
</div>
